<template>
    <v-main class="pa-2" fluid>
        <v-row>
            <v-btn @click="dialog = true" color="primary" dark>Add Resource</v-btn>
                <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                    <v-card color="lighten-1">
                        <v-toolbar>
                                <v-toolbar-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-form ref="form" v-model="valid" class="row">
                                        <v-col cols="12" md="12">
                                            <v-text-field readonly label="Name" v-model="editedItem.name" required></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                            <v-text-field label="Qty" v-model="editedItem.qty" required type="number"
                                            ></v-text-field>

                                            <v-select v-model="editedItem.unit"
                                            :items="['qts','gal','lt']"
                                            item-text="unit"
                                              :value="editedItem.unit"
                                            label="Unit"
                                            
                                            >
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                            <v-select v-model="editedItem.category"
                                            :items="['Aircrafts','Others']"
                                            item-text="category"
                                            item-value="category"
                                              :value="editedItem.category"
                                            label="Category"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-form>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            
        </v-row>

        <v-data-table
            :headers="headers"
            :items="resources"
            :items-per-page="10"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn><!-- 

                <v-btn icon small color="red" @click="deleteAgent(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn>

 -->
                </template>
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Qty', align: 'start', sortable: true, value: 'qty', },
                    { text: 'Unit', align: 'start', sortable: true, value: 'unit', },
                    { text: 'Category', align: 'start', sortable: true, value: 'category', },
                    { text: '', align: 'start', sortable: true, value: 'actions', },
                ],

                dialog: false,
                editedIndex: -1,

                valid: true,
                lazy: true,
                isEditing: null,

                editedItem: {
                    name: '',
                    qty: '',
                    category : '',
                    unit : '',
                    client_id : this.$store.state.uuid
                },

                

                req: [ v => !!(v && v.length) || 'Item is required'],
            }
        },

        mounted () {
            this.$store.dispatch('fetchResources')
        },


        computed: {
            ...mapState(['resources']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Resource' : 'Edit Resource'
            },
        },

        watch: {
            dialog (val) {
              //  val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.resources.indexOf(item);
                this.editedItem = Object.assign({}, item)



                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                this.editedItem.client_id = this.$store.state.uuid

                if (this.editedIndex > -1) {


                    axios.put('/api/resources/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.resources[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/resources', this.editedItem)
                    .then( response => {

                        this.resources.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              }
          }
    }
</script>